import { PromotersWithdrawRequestModule } from '@/modules/promoters/withdraw-request';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccessDenied } from '../../../../components/ui/access-denied';
import { useAccessControl } from '../../../../hooks/useAccessControl';

const withdrawalSearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(10),
  search: z.string().optional(),
  status: z.enum(['PENDING', 'APPROVED', 'REJECTED', 'PAID']).optional(),
  paymentType: z.enum(['WITHDRAWAL', 'CONVERSION']).optional(),
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/promoters/withdraw-request/')({
  validateSearch: withdrawalSearchSchema,
  component: PromotersWithdrawRequestPage,
});

function PromotersWithdrawRequestPage() {
  const { canAccessPromoterProfile } = useAccessControl();

  if (!canAccessPromoterProfile) {
    return <AccessDenied />;
  }

  return <PromotersWithdrawRequestModule />;
}
